import React from 'react';
import { Button } from 'aha-components';
import Drawer from '@material-ui/core/Drawer';
import { useTranslation } from 'react-i18next';

import { ReactComponent as CloseIcon } from '@/assets/icons/close.svg';

import styles from './bottomDrawer.module.less';
import '@/components/campaign/custom.less';
import { BackIcon } from '@/components/common/icon';

interface Props {
  children: any;
  width?: number;
  title?: string | React.ReactNode;
  isShowHeader?: boolean;
  isShowFooter?: boolean;
  visible: boolean;
  submitDisabled?: boolean;
  isLoading?: boolean;
  rootClassName?: string;
  rootStyle?: React.CSSProperties;
  className?: string;
  handleClose?: () => void;
  handleSubmit?: () => void;
  okText?: string;
  // cancelText?: string;
  keepMounted?: boolean;
  isShowBack?: boolean;
  isShowTopBack?: boolean;
  handleBack?: () => void;
  footer?: React.ReactNode;
  contentClassName?: string;
}

const bottomDrawerMaxHeight = 'calc(100dvh - env(safe-area-inset-top, 0px))';

const BottomDrawer: React.FC<Props> = ({
  children,
  title,
  visible,
  isShowHeader = true,
  isShowFooter = true,
  submitDisabled,
  isLoading,
  rootClassName,
  rootStyle,
  className,
  handleClose,
  handleSubmit,
  okText,
  // cancelText = 'Cancel',
  keepMounted = false,
  isShowBack = false,
  isShowTopBack = false,
  handleBack = () => {},
  footer,
  contentClassName
}) => {
  const { t } = useTranslation();

  okText = okText || t('common.modal.submit_btn', { defaultValue: 'Submit' });

  const hasCustomMaxHeight = className?.includes('max-h');

  return (
    <Drawer
      id="drawerCtn"
      anchor="bottom"
      open={visible}
      onClose={handleClose}
      keepMounted={keepMounted}
      classes={{
        root: rootClassName,
        paper: `${className || ''} flex flex-col overflow-hidden`
      }}
      PaperProps={{
        style: hasCustomMaxHeight
          ? undefined
          : {
              maxHeight: bottomDrawerMaxHeight
            }
      }}
      style={{ ...rootStyle }}
    >
      {isShowHeader && (
        <div
          className={
            styles.header +
            ' min-h-[20px] flex flex-shrink-0 items-center justify-between'
          }
        >
          {isShowTopBack && (
            <div onClick={handleBack} className="!h-[40px] !w-[40px]">
              <BackIcon />
            </div>
          )}
          <div className={styles.title}>{title}</div>
          <div onClick={handleClose}>
            <CloseIcon />
          </div>
        </div>
      )}
      <div
        className={`flex-1 min-h-0 overflow-y-auto ${contentClassName || ''}`}
      >
        {children}
      </div>
      {isShowFooter &&
        (footer ? (
          <div className="flex-shrink-0">{footer}</div>
        ) : (
          <div className={`${styles.footer} flex-shrink-0`}>
            <Button className="!h-[34px]" onClick={handleClose}>
              {t('common.drawer.cancel_btn', { defaultValue: 'Cancel' })}
            </Button>
            {isShowBack && (
              <Button className="!h-[34px]" onClick={handleBack}>
                {t('common.modal.back_btn')}
              </Button>
            )}
            <Button
              disabled={submitDisabled || isLoading}
              className="!h-[34px]"
              type="primary"
              loading={isLoading}
              onClick={handleSubmit}
            >
              {okText ? (
                okText
              ) : (
                <span>
                  {isLoading
                    ? t('common.drawer.submitting_btn', {
                        defaultValue: 'Submitting'
                      })
                    : t('common.drawer.submit_btn', { defaultValue: 'Submit' })}
                </span>
              )}
            </Button>
          </div>
        ))}
    </Drawer>
  );
};

export default BottomDrawer;
